/**
 * Marcom Module — API Client
 * Portable: Only depends on a base URL, no framework coupling.
 */
const API = ''; // Relative paths — works on any domain (preview + production)

const apiFetch = async (path, options = {}) => {
  const res = await fetch(`${API}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) {
    const detail = data.detail;
    const msg = typeof detail === 'string' ? detail : 'Request failed';
    throw new Error(msg);
  }
  return data;
};

export const marcoApi = {
  create: (payload) => apiFetch('/api/marcom', { method: 'POST', body: JSON.stringify(payload) }),
  list: () => apiFetch('/api/marcom'),
  get: (id) => apiFetch(`/api/marcom/${id}`),
  rename: (id, name) => apiFetch(`/api/marcom/${id}`, { method: 'PATCH', body: JSON.stringify({ name }) }),
  duplicate: (id) => apiFetch(`/api/marcom/${id}/duplicate`, { method: 'POST' }),
  delete: (id) => apiFetch(`/api/marcom/${id}`, { method: 'DELETE' }),
};

export const libraryApi = {
  upload: async (formData) => {
    const res = await fetch(`${API}/api/library`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Upload failed');
    return data;
  },
  bulkUpload: async (formData) => {
    const res = await fetch(`${API}/api/library/bulk-upload`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Bulk upload failed');
    return data;
  },
  list: (folderId) => apiFetch(`/api/library${folderId !== undefined ? `?folder_id=${folderId || ''}` : ''}`),
  get: (id) => apiFetch(`/api/library/${id}`),
  update: (id, data) => apiFetch(`/api/library/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (id) => apiFetch(`/api/library/${id}`, { method: 'DELETE' }),
  fileUrl: (id) => `${API}/api/library/${id}/file`,
  // Folder operations
  listFolders: () => apiFetch('/api/library/folders'),
  createFolder: (data) => apiFetch('/api/library/folders', { method: 'POST', body: JSON.stringify(data) }),
  updateFolder: (id, data) => apiFetch(`/api/library/folders/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  deleteFolder: (id) => apiFetch(`/api/library/folders/${id}`, { method: 'DELETE' }),
};
